import { IsArray, IsNotEmpty, IsObject } from "class-validator";

export class RoleDTO {

  @IsNotEmpty({ message: 'Le nom est requis' })
  name: string;

  @IsNotEmpty({ message: 'Les permissions sont requises' })
  @IsObject({ message: 'Le format de données est inccorect' })
  permissions: Record<string, Record<string, boolean>>;

}